import React, { useState, useEffect } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal } from "reactstrap";
import { compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { setCurrentCompany } from "../../../store/companies/actions";

const AppsDropdown = (props) => {
  const [modal_center, setmodal_center] = useState(false);
  const [singlebtn, setSinglebtn] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState("");

  useEffect(() => {
    setCompanies(props.companies);
  }, [props.companies]);

  useEffect(() => {
    setCompany(props.company || "");
  }, [props.company]);

  if (!companies || companies.length === 0) return null;

  const ChangeCompany = (c) => {
    props.changeCompany(c);
    setSinglebtn(false);
  };

  const isSelected = (c) => company && company.id === c.id;

  return (
    <React.Fragment>
      {/* Modal: instrucciones para agregar */}
      <Modal isOpen={modal_center} toggle={() => setmodal_center(!modal_center)} centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Agregar Estacionamiento</h5>
          <button type="button" onClick={() => setmodal_center(false)} className="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>
            Para agregar un Estacionamiento a esta cuenta, ingresa a
            TicketControl del Estacionamiento que te interesa agregar. Abre
            Configuración &rarr; Auditoría &rarr; Monitor e ingresa el correo electrónico
            de tu cuenta de TicketControl Monitor a la lista de email autorizados.
          </p>
        </div>
      </Modal>

      <Dropdown
        isOpen={singlebtn}
        toggle={() => setSinglebtn(!singlebtn)}
        className="dropdown d-inline-block ms-1"
        tag="li"
      >
        <DropdownToggle className="btn header-item noti-icon waves-effect" tag="button">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column my-0 py-0">
              <h5 className="m-3 mt-2 mb-0 mr-4 pr-2 d-none d-md-inline-block my-0 py-0 text-info">
                {company.name ? company.name.toUpperCase() : ""}
              </h5>
              {company.address && company.address.length > 0 && (
                <span
                  className="m-2 mr-4 mt-0 text-white pr-2 d-none d-md-inline-block my-0 py-0"
                  style={{ position: "relative", top: -4 }}
                >
                  <small className="text-light">
                    {company.address.toUpperCase()}
                  </small>
                </span>
              )}
            </div>
            <i className="ri-apps-2-line"></i>
          </div>
        </DropdownToggle>

        <DropdownMenu style={{ maxHeight: "400px", overflowY: "auto", minWidth: 280 }}>
          <div className="dropdown-header noti-title">
            <h5 className="font-size-13 text-muted text-truncate mn-0">
              Selecciona el Estacionamiento
            </h5>
          </div>

          {companies.map((c, key) => {
            const active = isSelected(c);
            return (
              <DropdownItem
                key={key}
                onClick={() => ChangeCompany(c)}
                className="py-2"
                style={{
                  backgroundColor: active ? "rgba(52, 195, 143, 0.1)" : "transparent",
                  borderLeft: active ? "3px solid #34c38f" : "3px solid transparent",
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: active ? 700 : 500, color: active ? "#34c38f" : "#343a40" }}>
                      {c.name}
                    </div>
                    {c.address && (
                      <div style={{ fontSize: 11, color: "#6c757d", textTransform: "uppercase" }}>
                        {c.address}
                      </div>
                    )}
                  </div>
                  {active && (
                    <span className="material-symbols-rounded text-success ms-2" style={{ fontSize: 18 }}>check_circle</span>
                  )}
                </div>
              </DropdownItem>
            );
          })}

          <div className="dropdown-divider"></div>
          <DropdownItem className="text-center" onClick={() => setmodal_center(true)}>
            <span style={{ fontSize: 13, color: "#6c757d" }}>
              <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>add_circle</span>Agregar Estacionamiento
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  companies: state.companies.companies,
  company: state.companies.currentCompany,
});

const mapDispatchToProps = (dispatch) => ({
  changeCompany: (company) => dispatch(setCurrentCompany(company)),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(AppsDropdown);
